export default __webpack_public_path__ + "static/media/article.f4012aec.jpg";